import { inject, Injectable } from '@angular/core';
import { TranslationService } from 'tms-lib';
import { Charts } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class TmsWebTranslationService {
  private readonly translationService = inject(TranslationService);

  load() {
    this.translationService.translateMenu = (key: string) => this.translateMenu(key);
    this.translationService.translateChart = (key: string) => this.translateChart(key);
  }

  translateMenu(value: string): string {
    switch (value) {
      case 'Addresses':
        return $localize`Addresses`;
      case 'Additional Product Costs':
        return $localize`Additional Product Costs`;
      case 'Administration':
        return $localize`Administration`;
      case 'Analysis':
        return $localize`Analysis`;
      case 'Application Settings':
        return $localize`Application Settings`;
      case 'Archive Invoices':
        return $localize`Archive Invoices`;
      case 'Banks':
        return $localize`Banks`;
      case 'Bonded Stock':
        return $localize`Bonded Stock`;
      case 'Bonded Stock Adjustment Reasons':
        return $localize`Bonded Stock Adjustment Reasons`;
      case 'Bonded Stock Analysis':
        return $localize`Bonded Stock Analysis`;
      case 'Bonded Stock Transaction Types':
        return $localize`Bonded Stock Transaction Types`;
      case 'Categories':
        return $localize`Categories`;
      case 'Charge Types':
        return $localize`Charge Types`;
      case 'Colours':
        return $localize`Colours`;
      case 'Commodity Codes':
        return $localize`Commodity Codes`;
      case 'Connections':
        return $localize`Connections`;
      case 'Connection Types':
        return $localize`Connection Types`;
      case 'Contact Types':
        return $localize`Contact Types`;
      case 'Countries':
        return $localize`Countries`;
      case 'Currencies':
        return $localize`Currencies`;
      case 'Credit Note Reasons':
        return $localize`Credit Note Reasons`;
      case 'Credit Notes':
        return $localize`Credit Notes`;
      case 'Custom Product Specs':
        return $localize`Custom Product Specs`;
      case 'Customer Documents':
        return $localize`Customer Documents`;
      case 'Customers':
        return $localize`Customers`;
      case 'Customer Orders':
        return $localize`Customer Orders`;
      case 'Customer Stock Enquiry':
        return $localize`Customer Stock Enquiry`;
      case 'Customer Sub Types':
        return $localize`Customer Sub Types`;
      case 'Customer Trade Groups':
        return $localize`Customer Trade Groups`;
      case 'Customer Types':
        return $localize`Customer Types`;
      case 'Customs Declaration':
        return $localize`Customs Declaration`;
      case 'Customs Transaction Types':
        return $localize`Customs Transaction Types`;
      case 'Delivery Periods':
        return $localize`Delivery Periods`;
      case 'Delivery Terms':
        return $localize`Delivery Terms`;
      case 'Designs':
        return $localize`Designs`;
      case 'Document':
        return $localize`Document`;
      case 'Documents':
        return $localize`Documents`;
      case 'Email Purchase Orders':
        return $localize`Email Purchase Orders`;
      case 'Email Sales Invoices':
        return $localize`Email Sales Invoices`;
      case 'Fabrics':
        return $localize`Fabrics`;
      case 'Funnel Files':
        return $localize`Funnel Files`;
      case 'Goods Delivery Notes':
        return $localize`Goods Delivery Notes`;
      case 'Goods Received Notes':
        return $localize`Goods Received Notes`;
      case 'Grades':
        return $localize`Grades`;
      case 'Held Orders':
        return $localize`Held Orders`;
      case 'Invoice Statuses':
        return $localize`Invoice Statuses`;
      case 'Label Placements':
        return $localize`Label Placements`;
      case 'Location Types':
        return $localize`Location Types`;
      case 'Locations':
        return $localize`Locations`;
      case 'Log in':
        return $localize`Log in`;
      case 'Log out':
        return $localize`Log out`;
      case 'Magento Products':
        return $localize`Magento Products`;
      case 'Magento Stock':
        return $localize`Magento Stock`;
      case 'Make Ups':
        return $localize`Make Ups`;
      case 'Manage Sales Orders':
        return $localize`Manage Sales Orders`;
      case 'Magento Sales Orders':
        return $localize`Magento Sales Orders`;
      case 'Magento Shipping Details':
        return $localize`Magento Shipping Details`;
      case 'Measure Descriptions':
        return $localize`Measure Descriptions`;
      case 'Month End Stock':
        return $localize`Month End Stock`;
      case 'Narratives':
        return $localize`Narratives`;
      case 'Modes Of Transport':
        return $localize`Modes Of Transport`;
      case 'Nominal Codes':
        return $localize`Nominal Codes`;
      case 'Order Line Statuses':
        return $localize`Order Line Statuses`;
      case 'Order Sources':
        return $localize`Order Sources`;
      case 'Order Statuses':
        return $localize`Order Statuses`;
      case 'Order Types':
        return $localize`Order Types`;
      case 'Origins':
        return $localize`Origins`;
      case 'Pack Types':
        return $localize`Pack Types`;
      case 'Payment Methods':
        return $localize`Payment Methods`;
      case 'Payment Terms':
        return $localize`Payment Terms`;
      case 'Payment Types':
        return $localize`Payment Types`;
      case 'Picking List':
        return $localize`Picking List`;
      case 'Picking List - Multi Select':
        return $localize`Picking List - Multi Select`;
      case 'Ports':
        return $localize`Ports`;
      case 'Price Bands':
        return $localize`Price Bands`;
      case 'Price Change Reasons':
        return $localize`Price Change Reasons`;
      case 'Price List':
        return $localize`Price List`;
      case 'Printers':
        return $localize`Printers`;
      case 'Print Methods':
        return $localize`Print Methods`;
      case 'Product Groups':
        return $localize`Product Groups`;
      case 'Product Type Groups':
        return $localize`Product Type Groups`;
      case 'Product Types':
        return $localize`Product Types`;
      case 'Production':
        return $localize`Production`;
      case 'Production Processes':
        return $localize`Production Processes`;
      case 'Products':
        return $localize`Products`;
      case 'Proforma Orders':
        return $localize`Proforma Orders`;
      case 'Proforma Payment Analysis':
        return $localize`Proforma Payment Analysis`;
      case 'Purchase Contract Book':
        return $localize`Purchase Contract Book`;
      case 'Purchase Contract Line Item':
        return $localize`Purchase Contract Line Item`;
      case 'Purchase Contracts':
        return $localize`Purchase Contracts`;
      case 'Purchase Deliveries':
        return $localize`Purchase Deliveries`;
      case 'Purchase Invoices':
        return $localize`Purchase Invoices`;
      case 'Purchase Orders':
        return $localize`Purchase Orders`;
      case 'Purchase Price Bands':
        return $localize`Purchase Price Bands`;
      case 'Purchase Order Production Item':
        return $localize`Purchase Order Production Item`;
      case 'Purchase Order Production Statuses':
        return $localize`Purchase Order Production Statuses`;
      case 'Purchase Order Book':
        return $localize`Purchase Order Book`;
      case 'Purchase Order Despatches':
        return $localize`Purchase Order Despatches`;
      case 'Purchase Orders for Completing':
        return $localize`Purchase Orders for Completing`;
      case 'Purchase Order Line Item':
        return $localize`Purchase Order Line Item`;
      case 'Purchase Order Receipts':
        return $localize`Purchase Order Receipts`;
      case 'Purchase Order Receipts - Multi Select':
        return $localize`Purchase Order Receipts - Multi Select`;
      case 'Purchase Order Statuses':
        return $localize`Purchase Order Statuses`;
      case 'Purchase Receipts':
        return $localize`Purchase Receipts`;
      case 'Purchasing':
        return $localize`Purchasing`;
      case 'Qualities':
        return $localize`Qualities`;
      case 'Relocate Stock':
        return $localize`Relocate Stock`;
      case 'Reporting':
        return $localize`Reporting`;
      case 'Reports':
        return $localize`Reports`;
      case 'Reserved Orders':
        return $localize`Reserved Orders`;
      case 'Returnable Product Orders':
        return $localize`Returnable Product Orders`;
      case 'Sales':
        return $localize`Sales`;
      case 'Sales Agents Commission':
        return $localize`Sales Agents Commission`;
      case 'Sales Contract Line Item':
        return $localize`Sales Contract Line Item`;
      case 'Sales Contracts':
        return $localize`Sales Contracts`;
      case 'Sales Despatch Notes':
        return $localize`Sales Despatch Notes`;
      case 'Sales Despatch Note Statuses':
        return $localize`Sales Despatch Note Statuses`;
      case 'Sales Discounts':
        return $localize`Sales Discounts`;
      case 'Sales Invoices':
        return $localize`Sales Invoices`;
      case 'Sales Analysis':
        return $localize`Sales Analysis`;
      case 'Sales Despatch Analysis':
        return $localize`Sales Despatch Analysis`;
      case 'Sales Manifest Items':
        return $localize`Sales Manifest Items`;
      case 'Sales Manifests':
        return $localize`Sales Manifests`;
      case 'Sales Order Analysis':
        return $localize`Sales Order Analysis`;
      case 'Sales Order Book':
        return $localize`Sales Order Book`;
      case 'Sales Orders for Completing':
        return $localize`Sales Orders for Completing`;
      case 'Sales Order Line Item':
        return $localize`Sales Order Line Item`;
      case 'Sales Order Line Multi Pick':
        return $localize`Sales Order Line Multi Pick`;
      case 'Sales Orders Not Passed Credit':
        return $localize`Sales Orders Not Passed Credit`;
      case 'Sales Order Payments':
        return $localize`Sales Order Payments`;
      case 'Sales Orders':
        return $localize`Sales Orders`;
      case 'Sales Packs':
        return $localize`Sales Packs`;
      case 'Sales Price Bands':
        return $localize`Sales Price Bands`;
      case 'Sales/Purchase Properties':
        return $localize`Sales Purchase Property`;
      case 'Sales Regions':
        return $localize`Sales Regions`;
      case 'Selling Companies':
        return $localize`Selling Companies`;
      case 'Service Reps':
        return $localize`Service Reps`;
      case 'Settings':
        return $localize`Settings`;
      case 'Settlement Terms':
        return $localize`Settlement Terms`;
      case 'Shipper Accounts':
        return $localize`Shipper Accounts`;
      case 'Shipper Account Interface Types':
        return $localize`Shipper Account Interface Types`;
      case 'Shipper Interface':
        return $localize`Shipper Interface`;
      case 'Shipping Charge Bands':
        return $localize`Shipping Charge Bands`;
      case 'Shipping Packs':
        return $localize`Shipping Packs`;
      case 'Shipping Payment Routes':
        return $localize`Shipping Payment Routes`;
      case 'Shipping Regions':
        return $localize`Shipping Regions`;
      case 'Shipping Services':
        return $localize`Shipping Services`;
      case 'Sizes':
        return $localize`Sizes`;
      case 'Stock':
        return $localize`Stock`;
      case 'Stock Adjustment Reasons':
        return $localize`Stock Adjustment Reasons`;
      case 'Stock Allocations':
        return $localize`Stock Allocations`;
      case 'Stock Enquiry':
        return $localize`Stock Enquiry`;
      case 'Stock Exposure':
        return $localize`Stock Exposure`;
      case 'Stock Forecasting':
        return $localize`Stock Forecasting`;
      case 'Stock for Cutting':
        return $localize`Stock for Cutting`;
      case 'Stock for Cutting by Order':
        return $localize`Stock for Cutting by Order`;
      case 'Stock Items':
        return $localize`Stock Items`;
      case 'Stock Item Transaction Analysis':
        return $localize`Stock Item Transaction Analysis`;
      case 'Stock Properties':
        return $localize`Stock Properties`;
      case 'Supplementary Invoices':
        return $localize`Supplementary Invoices`;
      case 'Supplementary Types':
        return $localize`Supplementary Types`;
      case 'Supplier Despatch Notes':
        return $localize`Supplier Despatch Notes`;
      case 'Supplier Documents':
        return $localize`Supplier Documents`;
      case 'Supplier Shipments':
        return $localize`Supplier Shipments`;
      case 'Suppliers':
        return $localize`Suppliers`;
      case 'Taxes':
        return $localize`Taxes`;
      case 'Third Party Shipper Accounts':
        return $localize`Third Party Shipper Accounts`;
      case 'Titles':
        return $localize`Titles`;
      case 'Trim Descriptions':
        return $localize`Trim Descriptions`;
      case 'Un-Bonded Stock Analysis':
        return $localize`Un-Bonded Stock Analysis`;
      case 'Unit of Measures':
        return $localize`Unit of Measures`;
      case 'Update External Orders':
        return $localize`Update External Orders`;
      case 'Update Shipped Orders':
        return $localize`Update Shipped Orders`;
      case 'Warehouses':
        return $localize`Warehouses`;
      case 'Website Shipping Details':
        return $localize`Website Shipping Details`;
    }

    return this.translationService.translateMenuItems(value);
  }

  translateChart(value: string): string {
    switch (value) {
      case Charts.SalesOrders:
        return $localize`Sales Orders`;
      case Charts.SalesInvoices:
        return $localize`Sales Invoices`;
      case Charts.SalesContracts:
        return $localize`Sales Contracts`;
      case Charts.PurchaseOrders:
        return $localize`Purchase Orders`;
      case Charts.PurchaseInvoices:
        return $localize`Purchase Invoices`;
      default:
        return undefined;
    }
  }
}
